import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Button, Image, TextInput } from "grommet";
import React from "react";
import { usePermission } from "../account/AccountStore";
import CustomButton from "../components/CustomButton";
import SkeletonWrapper from "../components/SkeletonWrapper";
import StyledModal from "../components/StyledModel";
import { AwardBadges } from "./AwardBadges";
import { BadgeCard } from "./BadgeCard";
import { BadgeViewModel, CreateBlanks, CreateFullBlanks, DeleteBadge, ListBadge } from "./BadgeStore";
import BadgeCreate from "./CreateBadge";
import { Routes, Route, useNavigate } from "react-router-dom";
import TournamentProfile from "../tournaments/TournamentProfile";
import BadgeProfile from "./BadgeProfile";
import BadgeRedemptionSetup from "./BadgeRedemptionSetup";
import BadgeBlanks from "./BadgeBlanks";

export const newBadgeIcon = (
    <span className="fa-layers fa-fw">
        {/* @ts-ignore */}
        <FontAwesomeIcon size="lg" icon={["fad", "image"]}></FontAwesomeIcon>
        <FontAwesomeIcon icon={["fad", "plus"]} swapOpacity transform="up-15 right-15" />
    </span>
);
export const newBlanksIcon = (
    <span className="fa-layers fa-fw">
        {/* @ts-ignore */}
        <FontAwesomeIcon size="lg" icon={["fad", "list-squares"]}></FontAwesomeIcon>
        <FontAwesomeIcon icon={["fad", "plus"]} swapOpacity transform="up-15 right-15" />
    </span>
);

export const assignBlanksIcon = (
    <span className="fa-layers fa-fw">
        {/* @ts-ignore */}
        <FontAwesomeIcon size="lg" icon={["fad", "list-squares"]}></FontAwesomeIcon>
        <FontAwesomeIcon icon={["fad", "check-square"]} swapOpacity transform="up-15 right-15" />
    </span>
);

const BadgeManagement = () => {
    const [loading, setLoading] = React.useState(true);

    const [badges, setBadges] = React.useState([] as BadgeViewModel[]);

    const listBadge = () => {
        setLoading(true);
        ListBadge(0, 50)
            .then((res) => {
                setBadges(res.result);
                setLoading(false);
            })
            .catch(() => {
                setBadges([]);
                setLoading(false);
            });
    };

    React.useEffect(() => {
        listBadge();
    }, []);

    const hasWritePermission = usePermission("sport:badges.write");
    const isAdmin = usePermission("admin");

    const [selectedBadge, setSelectedBadge] = React.useState({} as BadgeViewModel);

    const navigate = useNavigate();

    const [showCreateBlanksModal, setShowCreateBlanksModal] = React.useState(false);

    const startCreateBlanks = () => {
        setShowCreateBlanksModal(true);
    };

    const [blanksCount, setBlanksCount] = React.useState(0);

    const createBlanks = () => {
        CreateFullBlanks(blanksCount).then(() => {
            setShowCreateBlanksModal(false);
            navigate("/admin/badges/blanks");
        });
    };

    return (
        <Routes>
            <Route
                path={"create"}
                element={
                    <>
                        {hasWritePermission && (
                            <BadgeCreate
                                onCreated={() => {
                                    listBadge();
                                    navigate("/admin/badges");
                                }}
                            ></BadgeCreate>
                        )}
                    </>
                }
            ></Route>
            <Route path={"blanks"} element={<BadgeBlanks />}></Route>
            <Route path={":id/"} element={<BadgeProfile />}></Route>
            <Route path={":id/award"} element={<AwardBadges />}></Route>
            <Route path={":id/print"} element={<BadgeRedemptionSetup />}></Route>
            <Route
                path="/"
                element={
                    <Box pad={{ vertical: "small" }}>
                        {hasWritePermission && (
                            <Box direction="row" gap="small">
                                {hasWritePermission && <CustomButton onClick={() => navigate(`/admin/badges/create`)} icon={newBadgeIcon} label="New Badge"></CustomButton>}
                                {isAdmin && <CustomButton onClick={() => startCreateBlanks()} icon={newBlanksIcon} label="Create Blanks"></CustomButton>}
                                {isAdmin && <CustomButton onClick={() => navigate("/admin/badges/blanks")} icon={assignBlanksIcon} label="Assign Blanks"></CustomButton>}
                            </Box>
                        )}
                        <SkeletonWrapper loading={loading}>
                            <Box direction="row" gap="small" wrap>
                                {badges.map((c) => (
                                    <BadgeCard key={c.id} badge={c} onClick={() => navigate(`/admin/badges/${c.id}`)} />
                                ))}
                            </Box>
                        </SkeletonWrapper>

                        <StyledModal isOpen={showCreateBlanksModal} setIsOpen={setShowCreateBlanksModal}>
                            <Box>
                                <TextInput type="number" value={blanksCount} onChange={(e) => setBlanksCount(e.target.valueAsNumber)}></TextInput>
                                <Box direction="row">
                                    <Button primary label="Create Blanks" onClick={createBlanks}></Button>
                                </Box>
                            </Box>
                        </StyledModal>
                    </Box>
                }
            ></Route>
        </Routes>
    );
};

export default BadgeManagement;
